import React from "react";

export default function AddinInfo({ version, environment, accountEmail }) {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-header-dot" style={{ background: "var(--ms-teal)" }}></div>
        <h3>Add-in Information</h3>
      </div>
      <div className="card-body">
        <div className="setting-row">
          <div className="setting-label">Version</div>
          <span className="version-badge">{version}</span>
        </div>
        <div className="setting-row">
          <div className="setting-label">Environment</div>
          <span className="version-badge">{environment}</span>
        </div>
        <div className="setting-row" style={{ borderBottom: "none" }}>
          <div className="setting-label">Account</div>
          <span style={{ fontSize: 12, color: "var(--ms-neutral-90)" }}>{accountEmail}</span>
        </div>
      </div>
    </div>
  );
}
